
import React, { useState, useEffect } from 'react'
import { API_BASE_URL, GET_APPROVED_INDENTS } from '../../..//Config';
import Axios from "axios";
import { Link } from 'react-router-dom';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';


const ViewApprovedIndents = () => {

    const [userDataSession, setUserDataSession] = useState([]);
    const [pRApprovedData, setPRApprovedData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchValue, setSearchValue] = useState('');

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);
        } else {
            console.log("User data not found in sessionStorage");
        }
    }, []);


    // #region Get Approved Indents
    useEffect(() => {
        if (userDataSession && userDataSession.OrgId) {
            setLoading(true);
            Axios.get(`${API_BASE_URL}${GET_APPROVED_INDENTS}?OrgId=${userDataSession.OrgId}`)
                .then((response) => {
                    setPRApprovedData(response.data.ResultData);
                    console.log(response.data.ResultData)
                    setLoading(false);
                })
                .catch((error) => {
                    setLoading(false);
                    console.error("Error fetching approved indents:", error);
                });
        }
    }, [userDataSession]);

    const handleSearchChange = (e) => {
        setSearchValue(e.target.value);
    };

    const filteredData = pRApprovedData && pRApprovedData.filter(item => 
        item.IndentNO?.toString().toLowerCase().includes(searchValue.toLowerCase()) ||
        item.Name?.toLowerCase().includes(searchValue.toLowerCase()) ||
        item.ProductName?.toLowerCase().includes(searchValue.toLowerCase())
    );

    const generatePDF = () => {
        const doc = new jsPDF();
    
        const tableColumn = ["#", "Indent Number", "Store", "Product", "Requested Qty", "Approved Qty", "Current Stock"];
    
        const tableRows = filteredData.map((item, index) => [
            index + 1,
            item.IndentNO,
            item.Name,
            item.ProductName,
            item.ReqQty,
            item.Approvedqty || 'N/A',
            item.CurrentStock,
        ]);
    
        doc.autoTable({
            head: [tableColumn],
            body: tableRows,
            startY: 20,
            theme: 'grid',
        });
    
        doc.text("Approved Data", 14, 15);
    
        doc.save("ApprovedData.pdf");
    };

    const generateEXCEL = () => {
        const ws = XLSX.utils.json_to_sheet(pRApprovedData.map((item, index) => ({
            "#": index + 1,
            "Indent Number": item.IndentNO,
            "Store": item.Name,
            "Product": item.ProductName,
            "Requested Qty": item.ReqQty,
            "Approved Qty": item.Approvedqty || 'N/A',
            "Current Stock": item.CurrentStock
        })));
    
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Approved Data");
    
        XLSX.writeFile(wb, "ApprovedData.xlsx");
    };
    

    return (
        <div>
            {/* view indents */}
            <div
                className="offcanvas offcanvas-end"
                tabIndex={-1}
                id="offcanvasRightApprInds"
                aria-labelledby="offcanvasRightLabel"
                style={{ minWidth: '68%', maxWidth: '68%' }}
            >
                <div className="offcanvas-header">
                    <h4 id="offcanvasRightLabel">View Approved Indents</h4>
                    <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    />
                </div> <hr/>
                <div className="offcanvas-body">
                    <div className="search-set d-flex align-items-center justify-content-between">
                        <div className="search-input">
                            <input
                                type="text"
                                placeholder="Search"
                                className="form-control form-control-sm formsearch"
                                value={searchValue}
                                onChange={handleSearchChange}
                            />
                            <Link to="#" className="btn btn-searchset">
                                <i data-feather="search" className="feather-search" />
                            </Link>
                        </div>
                        <div className='d-flex'>
                            <div className='me-2'>
                                <Link onClick={generatePDF} title='Download PDF'>
                                    <img src="assets/img/icons/pdf.svg" style={{ width: '1.4rem' }} alt="img" />
                                </Link>
                            </div>
                            <div>
                                <Link onClick={generateEXCEL} title='Download EXCEL'>
                                    <img src="assets/img/icons/excel.svg" style={{ width: '2rem' }} alt="img" />
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="row my-2">
                        <div className="col-lg-12">
                            <div className="modal-body-table">
                                <div className="table-responsive" style={{ maxHeight: '35rem', overflowY: 'auto' }}>
                                    <table className="table datanew">
                                        <thead className='sticky-top'>
                                            <tr>
                                                <th>#</th>
                                                <th>Indent Number</th>
                                                <th>Store</th>
                                                <th>Product</th>
                                                <th>Requested Qty</th>
                                                <th>Approved Qty</th>
                                                <th>Current Stock</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="12" className="text-center">
                                                        <div className='loader m-auto'></div>
                                                    </td>
                                                </tr>
                                            ) : (
                                                filteredData?.length !== 0 ? (
                                                    filteredData?.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.IndentNO}</td>
                                                            <td>{item.Name}</td>
                                                            <td>{item.ProductName}</td>
                                                            <td className='text-info fw-bold'>{item.ReqQty}</td>
                                                            <td className='text-success fw-bold'>{item.Approvedqty ? item.Approvedqty : 'N/A'}</td>
                                                            <td className='text-primary fw-bold'>{item.CurrentStock}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="8" className="text-center">No Data available</td>
                                                    </tr>
                                                )
                                            )}
                                        </tbody>
                                    </table>     
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
                   
    )
}

export default ViewApprovedIndents
